import ValidationConfigSection from '../collateral/ValidationConfigSection';
import { Operation } from './OperationPageViewBackend';

interface Props {
    operation: Operation;
    operationId: string;
    onOperationChange: (op: Operation) => void;
    internalManagers: { value: string; label: string }[];
}

/**
 * Wrapper that maps structuring's Operation to collateral's ValidationConfigSection.
 */
const StructuringValidationConfigSection: React.FC<Props> = ({ operation }) => {
    const creditOpId = operation.credit_operations_id;

    const receivables = (operation.documents || []).flatMap((doc: any) =>
        (doc.receivables || []).map((r: any) => ({
            receivable_id: r.receivable_id,
            nfe_key: doc.document_id || '',
            receivable_number: r.receivable_number || '',
            title_number: doc.document_title || '',
            debtor_cpf_cnpj: doc.debtor_cpf_cnpj || '',
            debtor_name: doc.debtor_name || '',
            debtor_email: doc.debtor_email || '',
            debtor_phone: doc.address_phone || '',
            city: doc.address_city || '',
            state: doc.address_state || '',
            emission_date: doc.emission_date || doc.issue_date || '',
            amount: r.amount || 0,
            due_date: r.due_date || '',
        }))
    ).filter((r: any) => r.receivable_id);

    if (!creditOpId) return null;

    return (
        <ValidationConfigSection
            key={creditOpId}
            creditOperationId={creditOpId}
            operationCode={operation.operation_code}
            assignorName={operation.documents?.[0]?.assignor_name || ''}
            assignorTaxId={operation.documents?.[0]?.assignor_cnpj || ''}
            totalReceivables={operation.total_receivables}
            totalAmount={operation.total_amount}
            receivables={receivables}
            hideCriteriaAndIntensity
        />
    );
};

export default StructuringValidationConfigSection;
